import React from "react";
import {
  IMAGE_BASE_URL,
  SC_IMAGE_BASE_URL,
  SC_VIDEO_BASE_URL,
  BACKDROP_SIZE,
  POSTER_SIZE
} from "../../Config/config";
import "./EventPage.scss";
import "../../";
import { connect } from "react-redux";
import VideoPlayer from "../VideoPlayer/VideoPlayer"
import {
  selectMovieCast,
  selectMovieVideos
} from "../../Redux/Movie/movie-selectors";
import ItemPageFooter from "../ItemPageFooter/ItemPageFooter";
import { getAdditionalMovieData } from "../../Redux/Movie/movie-actions";
import { getAdditionalTVData } from "../../Redux/TVShow/tv-actions";
import Fade from "react-reveal/Fade";

class EventPage extends React.Component {
  componentDidMount() {
    return this.props.movies
      ? this.props.dispatch(getAdditionalMovieData(this.props.item.id))
      : this.props.dispatch(getAdditionalTVData(this.props.item.id));
    window.scrollTo(0, 0);
  }

  render() {
    const { item, movies, tvshow } = this.props;
    const {
      title,
      name,
      overview,
      backdrop_path,
      poster_path,
      video_path,
      vote_average
    } = item;
    const background = `${SC_IMAGE_BASE_URL}${backdrop_path}?alt=media`;
    const videoJsOptions = {
      autoplay: 'play',
      controls: true,
      height: 400,
      notSupportedMessage: "No se encuentra el video",
      sources: [{
        src: `${SC_VIDEO_BASE_URL}${video_path}?alt=media`,
        type: 'video/mp4'
      }]
    }
    return (
      <div className="item-page">
        <img
          src={`${background}`}
          alt="background"
          className="item-page__bg"
        />
        <div className="item">
          <Fade>
            <div className="item__outer">
              <div className="item__inner">
                <div className="item__text-box">
                  <h1 className="item__title">{title}</h1>
                  <VideoPlayer { ...videoJsOptions } />
                </div>
              </div>
            </div>
          </Fade>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  movieCast: selectMovieCast(state),
  movieVideos: selectMovieVideos(state)
});

export default connect(mapStateToProps)(EventPage);
